/**
 * @file コンポーネント：ローディング DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledLoading, StyledLoadingSpinner } from "./style";

// Presenterを返す
export const Presenter = () => {
    // ReactDOM
    return (
        <StyledLoading>
            <StyledLoadingSpinner>
                <i className="fas fa-spinner"></i>
            </StyledLoadingSpinner>
        </StyledLoading>
    );
};
